import projectOne from "../assets/project-1.png";
import projectTwo from "../assets/project-2.png";
import projectThree from "../assets/project-3.png";
import projectFour from "../assets/project-4.png";
import projectFive from "../assets/project-5.png";
import projectSix from "../assets/project-6.png";

const projects = {
  1: {
    title: "HOME HARBOR",
    image: projectFour,
    description: (
      <>
        <p>
          HomeHarbor: Your Real Estate Solution: HomeHarbor serves as a reliable
          guide in the realm of real estate. Our platform offers a seamless
          experience, enabling you to effortlessly navigate the vast landscape
          of property transactions. Whether you are in search of a new abode,
          aiming to sell your property.
        </p>
      </>
    ),
    github: "https://github.com/sameerkali/Home-Harbor",
    demo: "https://home-harbour.onrender.com/"
  },
  2: {
    title: "Indie Gems Portal",
    image: projectOne,
    description: (
      <>
        <p>
          Indie Gems Portal is a web application that allows users to search for
          games based on genres, platforms, release dates, and ratings. It
          provides a convenient way to explore and find games that match your
          preferences.
        </p>
      </>
    ),
    github: "https://github.com/sameerkali/Indie_Gems_Portal",
    demo: "https://indie-gems-portal.vercel.app/"
  },
  3: {
    title: "Film Sloth",
    image: projectTwo,
    description: (
      <>
        <p>
          🕵️‍♂️ FilmSloth: Unlock cinematic secrets! Discover hidden 🎥 gems
          effortlessly and delve into the world of entertainment with our
          intuitive app.
          <code>#React18 #TMDB #API #materialUI #vite</code>
        </p>
      </>
    ),
    github: "https://github.com/sameerkali/FilmSloth",
    demo: "https://filmsloth.netlify.app/"
  },

  4: {
    title: "Explorer Mount",
    image: projectFive,
    description: (
      <>
        <p>
          At Explore Mount, were on a mission to be your trusted companion on
          every journey you embark upon, whether its a spontaneous road trip or
          a meticulously planned Global adventure. We understand the sheer joy
          of witnessing the unspoiled beauty of nature and the thrill of
          discovering New places, cultures, and experiences.
        </p>
      </>
    ),
    github: "https://github.com/sameerkali/explorer-mount",
    demo: "https://explorer-mount.vercel.app/"
  },
  5: {
    title: "FitHub",
    image: projectSix,
    description: (
      <>
        <p>
          FitHub is a straightforward and visually appealing landing page
          specifically crafted for gyms and fitness centers. It offers a
          pristine and efficient online representation, aiming to allure
          prospective clientele and exhibit the comprehensive range of amenities
          and services provided by the gym.
        </p>
      </>
    ),
    github: "https://github.com/sameerkali/fit-hub",
    demo: "https://fithub-kappa.vercel.app/"
  },
  6: {
    title: "Portfolio for client",
    image: projectThree,
    description: (
      <>
        <p>
          Welcome to my cutting-edge Personal Portfolio Project! 🚀 In This
          project, Ive harnessed the power of modern technologies to create a
          unique and immersive experience for showcasing my artistic endeavors.
        </p>
      </>
    ),
    github: "https://github.com/sameerkali/portfolio69",
    demo: "https://sameer69.netlify.app/"
  }
};

export default projects;
